// extracted by mini-css-extract-plugin
module.exports = {"highlight":"E3Y0Zz9oEppwO0QoNYk3iw==","actionWrap":"ht8qEDHnmTeT930w9sNSxw==","praise":"ztzEaQZEIxy8OGtfEC6ASg==","switchWrap":"gmejaCUZxhNjBIVekvXNHQ=="};